import React, { memo } from 'react';
import {
    Popper,
    Paper,
    ClickAwayListener,
} from '@mui/material';
import { CSSProperties } from '@mui/material/styles/createTypography';

export interface GeneralPopperOptions { }

interface GeneralPopperProps extends GeneralPopperOptions {
    anchorEl: any;
    headerText?: string;
    element?: React.ReactNode;
    popperStyle?: CSSProperties;
    handleGeneralPopperClose: () => void;
}

export const GeneralPopper: React.FC<GeneralPopperProps> = props => {
    const {
        anchorEl,
        headerText,
        element,
        popperStyle,
        handleGeneralPopperClose,
    } = props;

    return (
        <ClickAwayListener onClickAway={() => setTimeout(handleGeneralPopperClose, 5)}>
            <Popper
                onClick={(event) => event.stopPropagation()}
                style={{ position: 'fixed', ...popperStyle }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal={false}
                popperOptions={{
                    strategy: 'fixed',
                }}
                modifiers={[
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['bottom-start'],
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport',
                        },
                    },
                ]}
            >
                <Paper className="pb-popover pb-popover--menu">
                    {headerText && (
                        <div className="pb-popover-title">{headerText}</div>
                    )}
                    {element}
                </Paper>
            </Popper>
        </ClickAwayListener>
    );
};

export default memo(GeneralPopper);